import requests from "./api/base-api";

const SignalsService = {
  getAllSymbol: (params) => requests.getByParams(`/currency/v1/user-get-all-currency-Name`, params),
  uploadSignal: (body) => requests.post(`/signal/v1/create-signal-user`, body),

  // getAll: (params) => requests.get(`/signal/v1/get-all-signals-user`, { params })
  getAll: (params) => requests.getByParams(`/signal/v1/get-all-signals-user`, params),
  getSignalById: (id) => requests.get(`/signal/v1/get-signal-user/${id}`),

    getMySignal: () =>requests.get('/signal/v1/get-my-siganl'),

  getSignalComments: (signalId) => requests.get(`/comment/get-all-signal/${signalId}`),
  postSignalComment: (body) => requests.post(`/comment/comment-create-signal`, body),

  likeSignal: (data) => requests.post(`/signal/v1/signal-like`, data),
  disLikeSignal: (data) => requests.post(`/signal/v1/signal-dislike`, data),

  subscribePackageSignal: (body) => requests.patch('/package/v1/subscribe-package-signal', body),

  //Retrieves the list of signals sorted by the highest number of likes.
  getBestSignals: (params) => requests.getByParams(`/signal/v1/get-best-signals`, params),
};

export default SignalsService;